import BaseParser from './BaseParser';
import { TOOL_TYPE } from './ToolType';

/**
 * ContentReferencesParser - Parser para referencias de contenido
 *
 * Convierte patrones [CONTENT_REFERENCES]...[/CONTENT_REFERENCES] a parts específicos
 * para renderizar las referencias de contenido educativo (cursos, unidades, lecciones)
 */
class ContentReferencesParser extends BaseParser {
  constructor() {
    super('ContentReferences', 2); // Prioridad alta
  }

  getPatterns() {
    return [/\[CONTENT_REFERENCES\](.*?)\[\/CONTENT_REFERENCES\]/gs];
  }

  extractMatches(content) {
    const matches = [];
    const pattern = this.getPatterns()[0];
    let match;

    // Reset regex
    pattern.lastIndex = 0;

    while ((match = pattern.exec(content)) !== null) {
      let jsonContent = match[1].trim();
      let references = [];

      try {
        // Parsear el JSON tal como viene
        references = JSON.parse(jsonContent);
      } catch (error) {
        console.warn('Error parsing content references JSON:', error);
        references = [];
      }

      matches.push({
        index: match.index,
        length: match[0].length,
        type: TOOL_TYPE.CONTENT_REFERENCES,
        originalMatch: match[0],
        references: references,
      });
    }

    return matches;
  }

  convertContent(content) {
    // Mantenemos el contenido original para que extractMatches pueda procesarlo
    return content;
  }

  createPart(match) {
    return {
      type: TOOL_TYPE.CONTENT_REFERENCES,
      references: match.references,
    };
  }
}

export default ContentReferencesParser;
